import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as bookApi from '../../services/api/bookApi';
import routerHistory from '../../routerHistory';
import { ACTIVITY_TYPE, ROUTES } from '../../const';
import { bindActionCreators } from 'redux';
import * as searchActions from '../../actions/search/searchActions';
import SearchElement from '../../dto/search/SearchElement';
import SearcherComponent from './searcher/SearcherComponent';
import unitDefaultImage from './../../images/unit.svg';
import { getClassroomImageUrl } from './../../services/assets/assetsService';
import Media from 'react-media';
import { MOBILE_MEDIA_QUERY } from '../../utils/mobileUtils';

class Searcher extends React.Component {
  static propTypes = {
    classrooms: PropTypes.array,
    searchActions: PropTypes.any,
    currentClassroom: PropTypes.any,
    currentBook: PropTypes.any,
    bookDefaultImg: PropTypes.string,
    lessonImages: PropTypes.any,
    searchMode: PropTypes.bool
  };

  state = {
    query: '',
    books: [],
    searchResult: [],
    priorityResults: []
  };

  // On mobile the class ⋮ sheet can turn search mode on while this component is not mounted
  componentDidMount() {
    if (this.props.searchMode) {
      this.loadBooks();
    }
  }

  render() {
    return (
      <Media query={MOBILE_MEDIA_QUERY}>
        {matches => (
          <div className={matches || (!matches && !this.props.searchMode) ? '' : 'searchbox-container'}>
            <SearcherComponent
              inputValue={this.state.query}
              searchResults={this.state.searchResult}
              searchMode={this.props.searchMode}
              events={{
                onInputChange: e => {
                  this.setState({ query: e.target.value });
                  this.query = e.target.value;
                  this.executeSearch();
                },
                onBrowserClick: this.loadBooks,
                onSubmit: e => {
                  this.routeToSearchDetails(e);
                },
                onClose: () => {
                  this.props.searchActions.setSearchMode(false);
                  this.setState({ query: '' });
                }
              }}
            />
          </div>
        )}
      </Media>
    );
  }

  executeSearch() {
    const { searchActions, currentClassroom, currentBook } = this.props;
    searchActions.setSearchResult(this.searchInBooks());
    searchActions.setContext({
      classroom: currentClassroom ? currentClassroom.id : undefined,
      book: currentBook ? currentBook.id : undefined
    });
  }

  loadBooks = () => {
    this.props.searchActions.setSearchMode(true);
    if (this.state.books.length === 0) {
      const books = [];
      this.props.classrooms.map(classroom => {
        bookApi.getBooks(classroom.id).then(bookResponse => {
          bookResponse.data.map(book => {
            bookApi.getBook(classroom.id, book.id).then(cmi5 => {
              book.units = cmi5.data;
              books.push(book);
              this.setState({ books: books });
            });
          });
        });
      });
    }
  };

  searchInBooks = () => {
    let searchResult = [];
    this.state.books.map(book => {
      const shouldHavePriority =
        this.props.currentClassroom.id === book.sectionId || this.props.currentBook.id === book.id;
      const classroom = this.props.classrooms.find(classroom => classroom.id === book.sectionId);
      const matchedUnits = this.searchInUnits(book, classroom);
      const bookName = Object.values(JSON.parse(book.name))[0];
      const element = new SearchElement(
        classroom.id,
        classroom.name,
        book.id,
        bookName,
        null,
        null,
        bookName,
        ACTIVITY_TYPE.BOOK,
        this.getBookImageUrl(book),
        this.getClassroomImageUrl(classroom)
      );

      if (shouldHavePriority) {
        matchedUnits.map(unit => searchResult.unshift(unit));
        if (matchedUnits.length === 0) {
          const search = this.searchInObject(book);
          if (search !== -1) {
            searchResult.unshift(element);
          }
        }
      } else {
        searchResult = searchResult.concat(matchedUnits);
        if (matchedUnits.length === 0) {
          const search = this.searchInObject(book);
          if (search !== -1) {
            searchResult.push(element);
          }
        }
      }
    });

    this.setState({ searchResult });
    return searchResult;
  };

  searchInUnits = (book, classroom) => {
    const bookName = Object.values(JSON.parse(book.name))[0];
    let searchResult = [];
    book.units.auOrBlock.map(unit => {
      const matchedLessons = this.searchInLessons(unit, book, classroom);
      searchResult = searchResult.concat(matchedLessons);
      const unitSearch = this.searchInObject(unit);
      if (matchedLessons.length === 0 && unitSearch !== -1) {
        const element = new SearchElement(
          classroom.id,
          classroom.name,
          book.id,
          bookName,
          unit.id,
          null,
          Object.values(unit.title)[0],
          ACTIVITY_TYPE.UNIT,
          this.getUnitImageUrl(),
          this.getClassroomImageUrl(classroom)
        );
        searchResult.push(element);
      }
    });
    return searchResult;
  };

  searchInLessons = (unit, book, classroom) => {
    const bookName = Object.values(JSON.parse(book.name))[0];
    const searchResult = [];
    unit.auOrBlock.map(lesson => {
      const lessonSearch = this.searchInObject(lesson);
      if (lessonSearch !== -1) {
        const element = new SearchElement(
          classroom.id,
          classroom.name,
          book.id,
          bookName,
          unit.id,
          lesson.id,
          Object.values(lesson.title)[0],
          ACTIVITY_TYPE.LESSON,
          this.getLessonImageUrl(lesson),
          this.getClassroomImageUrl(classroom)
        );
        element.primary = true;
        searchResult.push(element);
      }
    });
    return searchResult;
  };

  searchInObject = object => {
    return JSON.stringify(object)
      .toLowerCase()
      .search(this.query.toLowerCase());
  };

  getBookImageUrl = book => {
    return book.image || this.props.bookDefaultImg;
  };

  getUnitImageUrl = unit => {
    return unitDefaultImage;
  };

  getLessonImageUrl = lesson => {
    return lesson.image || this.props.lessonImages.default;
  };

  getClassroomImageUrl = classroom => {
    return getClassroomImageUrl(classroom.id, classroom.picture || classroom.asset);
  };

  routeToSearchDetails = e => {
    if (this.query) {
      routerHistory.push(ROUTES.SEARCH_RESULTS);
    }
  };
}

function mapDispatchToProps(dispatch) {
  return {
    searchActions: bindActionCreators(searchActions, dispatch),
    dispatch
  };
}

function mapStateToProps(state) {
  return {
    classrooms: state.classrooms.activeClassrooms,
    currentClassroom: state.classrooms.selectedClassroom.classroom,
    currentBook: state.book.book,
    bookDefaultImg: state.theme.images.placeholders.book,
    lessonImages: state.theme.images.placeholders.lesson,
    searchMode: state.search.searchMode
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Searcher);
